export type CertificateAlign = "left" | "center" | "right";
export type CertificateOrientation = "portrait" | "landscape";
export type CertificateElementType = "text" | "logo";
export type CertificateSection = "header" | "body" | "footer";
export type LabelValueStyle = "inline" | "stacked";

export type CertificateElement = {
  id: string;
  type: CertificateElementType;
  label: string;
  section: CertificateSection;
  x: number;
  y: number;
  width: number;
  height: number;
  content: string;
  visible: boolean;
  fontSize: number;
  fontWeight: number;
  fontFamily?: string;
  align: CertificateAlign;
  lineHeight: number;
  letterSpacing?: number;
  textTransform?: "none" | "uppercase" | "capitalize";
  color?: string;
  fieldKey?: string;
};

export type CertificatePageSettings = {
  size: "A4";
  orientation: CertificateOrientation;
  marginMm: number;
  fontFamily: string;
  fontSize: number;
  fontWeight: number;
  lineHeight: number;
  textAlign: CertificateAlign;
  logoSrc: string;
  logoSizeMm: number;
  fieldSpacing: number;
  paragraphSpacing: number;
  labelValueStyle: LabelValueStyle;
  showSafeArea: boolean;
  headerAlign: CertificateAlign;
  footerText: string;
};

export type CertificateTemplate = {
  id: string;
  name: string;
  page: CertificatePageSettings;
  elements: CertificateElement[];
};

export type CertificateDesignerStore = {
  templates: CertificateTemplate[];
  activeId: string;
  defaultId: string;
};

export const A4_PORTRAIT = { widthMm: 210, heightMm: 297 } as const;
export const A4_LANDSCAPE = { widthMm: 297, heightMm: 210 } as const;

export function getPageSize(orientation: CertificateOrientation) {
  return orientation === "landscape" ? A4_LANDSCAPE : A4_PORTRAIT;
}
